
























import { FundingSource } from '@/types/Payments'
import { removeFundingSource } from '@/services/payments'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class RemoveFundingSourceDialog extends Vue {

  @Prop({ default: false }) readonly opened!: boolean
  @Prop({ default: false }) loading!: boolean
  @Prop(Object) readonly fundingSource!: FundingSource

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async removeFundingSource() {
    this.loading = true
    await removeFundingSource(this.$store, this.fundingSource._links.self.href)
    this.loading = false
    this.closeDialog()
  }

}
